module.exports = __webpack_public_path__ + "static/media/error-disconnection.1fd663e0.svg";